import { Component, OnDestroy, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Subscription } from 'rxjs';
import { exhaustMap, tap } from 'rxjs/operators';
import { AppState } from '../../models/app-state.model';
import { AppStateService } from '../../services/app-state.service';

@Component({
    selector: 'app-full-layout',
    templateUrl: './full-layout.component.html',
    styleUrls: ['./full-layout.component.scss']
})

export class FullLayoutComponent implements OnInit, OnDestroy {
    isIframe = false;
    cookieBannerClosed = false;
    cookieName = 'cookieBanner';
    public appState: AppState;
    private subscription: Subscription;
    constructor(private cookieService: CookieService,
        private appStateService: AppStateService) { }

    ngOnInit() {
        this.isIframe = window !== window.parent && !window.opener;
        this.cookieBannerClosed = this.cookieService.check(this.cookieName);
        this.subscription = this.appStateService.pageInit$.pipe(
            exhaustMap(() => this.appStateService.getState()),
            tap(result => this.appState = result)
        ).subscribe();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    public closeCookieBanner(): void {
        this.cookieService.set(this.cookieName, 'closed', 10000);
        this.cookieBannerClosed = true;
    }
}